import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const TechPermissionsContext = createContext({
  permissions: null,
  phoneVisible: true,
  callMaskingEnabled: false,
  loaded: false,
  refresh: () => {},
});

export const useTechPermissions = () => useContext(TechPermissionsContext);

// allowed(perms, key): existing capabilities stay usable while perms load;
// backend is the enforcement authority either way.
export const allowed = (permissions, key) => (permissions ? permissions[key] !== false : true);
// enabled(perms, key): NEW capabilities render only when explicitly granted.
export const enabled = (permissions, key) => !!(permissions && permissions[key] === true);

export const TechPermissionsProvider = ({ children }) => {
  const [state, setState] = useState({
    permissions: null, phoneVisible: true, callMaskingEnabled: false, loaded: false,
  });

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/tech/permissions`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("tech_token")}` },
      });
      setState({
        permissions: res.data.permissions || {},
        phoneVisible: res.data.phone_visible !== false,
        callMaskingEnabled: !!res.data.call_masking_enabled,
        loaded: true,
      });
    } catch {
      setState((s) => ({ ...s, loaded: true }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <TechPermissionsContext.Provider value={{ ...state, refresh }}>
      {children}
    </TechPermissionsContext.Provider>
  );
};
